module.exports = __webpack_public_path__ + "img/icon-chevron-down-blue.a6b86ae6.svg";